var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 0C5.98125 0 5.55312 0.145345 5.25 0.445312C4.94688 0.74528 4.8 1.16895 4.8 1.58333V2.375H0V3.95833H0.8V16.625C0.8 17.9269 1.88438 19 3.2 19H12.8C14.1156 19 15.2 17.9269 15.2 16.625V3.95833H16V2.375H11.2V1.58333C11.2 1.16895 11.0531 0.74528 10.75 0.445312C10.4469 0.145345 10.0188 0 9.6 0H6.4ZM6.4 1.58333H9.6V2.375H6.4V1.58333ZM2.4 3.95833H13.6V16.625C13.6 17.0641 13.2438 17.4167 12.8 17.4167H3.2C2.75625 17.4167 2.4 17.0641 2.4 16.625V3.95833ZM4 6.33333V15.0417H5.6V6.33333H4ZM7.2 6.33333V15.0417H8.8V6.33333H7.2ZM10.4 6.33333V15.0417H12V6.33333H10.4Z",
    fill: "#61AB51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.82fcbbb09c895f81018ed5c0868828c2.svg";
export { ForwardRef as ReactComponent };